exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-2197c9d8]{color:#fff;font-size:18px;font-weight:300;text-decoration:none;padding:5px}.headWrapper[data-v-2197c9d8]{position:fixed;top:0;left:0;bottom:0;right:0;margin:0;width:100%;overflow:none;background-color:rgba(0,0,0,.7);height:80px;z-index:99}.subMenuWrapper[data-v-2197c9d8]{position:fixed;top:50px;right:25px;background-color:rgba(0,0,0,.7);min-width:160px;box-shadow:0 8px 16px 0 rgba(0,0,0,.2);z-index:99!important}.subMenuList[data-v-2197c9d8]{list-style:none}.subMenuList li[data-v-2197c9d8]{margin-top:10px;margin-bottom:20px;margin-left:-30px}.subMenuList li a[data-v-2197c9d8]:hover{color:#fff;background-color:rgba(0,0,0,.7)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2197c9d8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header/Index.vue
// module id = 68
// module chunks = 0